
/**
 * 单选按钮
 * wangj
 */

const SgiFormRadioEO = function () {
    return {
        // isBtn:false,
        // checked:'1',
        // c : "col2",
        ctlH: 0,
        ctlN: "单选框",
        ctlW: 24,
        desId: "EP_EO_UI_3109",
        isDis: false,
        isHdn: false,
        lblAlg: "right",
        lblW: 6,
        // n : "字段2",
        sNo: 0,
        // scId: 'SD_SC_PT_0001',//标准代码GUID
        // t : "radio",
        te: '单选框组',
        // ctlClu:1,
        // useCodes:'',

        alwBlk: true,
        // isGw : false,
        // isLbl : true,
        // isRead : false,
        // isSrp : true,

        // maxL : 0,
        // minL : 0,
        // msfTgt : "qtip",
        // useTim : 0,
        // visible : true,
        // x : "0",
        // y : "0",
    }
}

export { SgiFormRadioEO };
export default SgiFormRadioEO;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiFormRadioEO.js